module.exports = __webpack_public_path__ + "static/img/4areaB_2.bc63332.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/4areaB_2.png
// module id = 1182
// module chunks = 1